import { Feature } from 'ol';
import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';

export default {
  methods: {
    isCustomLayerAdded(id) {
      return this.getLayerById(id) ? true : false;
    },
    clearCustomLayer(id) {
      if (this.isCustomLayerAdded(id)) {
        this.getLayerById(id)
          .getSource()
          .clear();
      }
    },
    customLayerAddFeature(feature, id) {
      if (this.isCustomLayerAdded()) {
        this.getLayerById(id)
          .getSource()
          .addFeature(feature);
      }
    },
    addCustomLayer(geometry, id, layerParams) {
      const featureFromGeom = new Feature({ geometry: geometry });
      if (this.isCustomLayerAdded(id)) {
        this.clearCustomLayer(id);
        this.customLayerAddFeature(featureFromGeom, id);
      } else {
        const newLayer = new VectorLayer({
          id,
          isSpecial: true,
          zIndex: layerParams.zIndex || 999,
          opacity: layerParams.opacity || 1,
          source: new VectorSource({
            features: [featureFromGeom],
          }),
          style: layerParams.style,
        });
        this.map.addLayer(newLayer);
      }
    },
  },
};
